import _cloneDeep from 'lodash/cloneDeep';

export default {
  authorityGroupsResults: (state) => _cloneDeep(state.authorityGroupsResults),
};
